(function () {
  (function detectCollectionPagination() {
    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get('page');

    if (page && parseInt(page, 10) > 1) {
      document.body.classList.add('collection_pagination');
    }
  })();

  const element1 = document.querySelector('.collection_top_block__short_description--absolute');
  const element2 = document.querySelector('.collection_top_block__image_container_inner_white_block');

  if (element1 && element2) {
    const updateElement2Height = function () {
      const rect = element1.getBoundingClientRect();
      element2.style.height = rect.height + 24 + 'px';
    };

    updateElement2Height();
    window.addEventListener('resize', updateElement2Height);
  }

  const toggleButton = document.getElementById('toggleButton');
  const container = document.querySelector('.collection_filter_models__list');

  if (toggleButton && container) {
    const containerMaxHeight = parseInt(window.getComputedStyle(container).maxHeight, 10);

    if (containerMaxHeight > container.offsetHeight) {
      toggleButton.classList.add('hidden');
    }

    toggleButton.addEventListener('click', function () {
      const elementsLength = document.querySelectorAll('.collection_filter_models__list_item').length;

      if (elementsLength > 60) {
        this.style.display = 'block';
      }

      if (container.style.maxHeight) {
        container.style.maxHeight = null;
        this.textContent = 'Show More';
      } else {
        container.style.maxHeight = container.scrollHeight + 'px';
        this.textContent = 'Show Less';
      }
    });
  }
})();
